module.exports = __webpack_public_path__ + "img/phase-2.fa5c2a59.svg";